import UrlPattern from 'url-pattern';

export const PATH_NAME = {
  AUDIT: 'AUDIT',
  CAMPAIGN: 'CAMPAIGN',
  CAMPAIGN_FILE: 'CAMPAIGN_FILE',
  CUSTOMIZE: 'CUSTOMIZE',
  APPOINTMENT: 'APPOINTMENT',
  INTERVENTION: 'INTERVENTION',
  INTERVENTION_ENTITIES: 'INTERVENTION_ENTITIES',
  DEALERS_KEY_DEPOSIT: 'DEALERS_KEY_DEPOSIT',
  CUSTOMER_LEAD_UNSUBSCRIBE: 'CUSTOMER_LEAD_UNSUBSCRIBE',
  FOLLOW_UP: 'FOLLOW_UP',
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  TEST: 'TEST',
  PAGE_404: 'PAGE_404',
};

export const PATH = {
  [PATH_NAME.AUDIT]: new UrlPattern('/audits/api/:uuid'),
  [PATH_NAME.CAMPAIGN]: new UrlPattern('/campaigns/api/:uuid'),
  [PATH_NAME.CAMPAIGN_FILE]: new UrlPattern('/campaigns/api/:uuid/files/:campaignFileId'),
  [PATH_NAME.CUSTOMIZE]: new UrlPattern('/templates/api/:uuid'),
  [PATH_NAME.APPOINTMENT]: new UrlPattern('/appointments/api/:uuid'),
  [PATH_NAME.INTERVENTION]: new UrlPattern('/interventions/api/:uuid'),
  [PATH_NAME.INTERVENTION_ENTITIES]: new UrlPattern('/interventionEntities/api/:mode/:uuid'),
  [PATH_NAME.DEALERS_KEY_DEPOSIT]: new UrlPattern('/dealers/api/:uuid/keyDeposit'),
  [PATH_NAME.CUSTOMER_LEAD_UNSUBSCRIBE]: new UrlPattern('/customers/api/:customerId/leads/:leadId/anonymize'),
  [PATH_NAME.FOLLOW_UP]: new UrlPattern('/followUps/api/:uuid'),
  [PATH_NAME.UNSUBSCRIBE]: new UrlPattern('/unsubscribe'),
  [PATH_NAME.TEST]: new UrlPattern('/test/:mode'),
  [PATH_NAME.PAGE_404]: new UrlPattern('/404'),
};

export const UNFETCHABLE_PATHS = [
  PATH_NAME.TEST,
  PATH_NAME.PAGE_404,
  PATH_NAME.UNSUBSCRIBE,
  PATH_NAME.CUSTOMER_LEAD_UNSUBSCRIBE,
];

export const READ_ONLY_PAGES = [PATH_NAME.DEALERS_KEY_DEPOSIT];

export const URL_REGEX = /(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.]*\)|[A-Z0-9+&@#\/%=~_|$])/im;
